export const FaqSection = () => {
  const faqs = [
    {
      id: 'naturopathie-consultation',
      question: "Qu'est-ce que la naturopathie et comment se déroule une consultation à Angoulême ?",
      answer: "La naturopathie est une approche de santé naturelle et holistique qui vise à renforcer les défenses de l'organisme par des moyens naturels. Lors d'une consultation avec votre naturopathe à Angoulême, Laura Body réalise un bilan complet de votre hygiène de vie (alimentation, sommeil, stress, activité physique) afin de vous proposer un accompagnement personnalisé. La première séance dure environ 1h30."
    },
    {
      id: 'reflexologie-plantaire',
      question: 'Comment fonctionne la réflexologie plantaire ?',
      answer: "La réflexologie plantaire est une technique manuelle qui consiste à stimuler des zones réflexes situées sous les pieds. Chaque zone correspond à un organe ou une partie du corps. En exerçant des pressions spécifiques, la réflexologie favorise la détente, stimule les capacités d'auto-régulation du corps et contribue à rétablir l'équilibre énergétique. Les séances de réflexologie à Angoulême durent environ 1 heure."
    },
    {
      id: 'remboursement',
      question: 'La naturopathie est-elle remboursée par la sécurité sociale ?',
      answer: "La naturopathie n'est pas remboursée par la sécurité sociale. Cependant, de nombreuses mutuelles proposent aujourd'hui des forfaits \"médecines douces\" ou \"bien-être\" qui peuvent prendre en charge tout ou partie de vos séances de naturopathie et de réflexologie. N'hésitez pas à vous renseigner auprès de votre mutuelle."
    },
    {
      id: 'problemes-consulter',
      question: 'Pour quels problèmes consulter une naturopathe à Angoulême ?',
      answer: "Vous pouvez consulter votre naturopathe à Angoulême pour de nombreuses problématiques : stress, troubles du sommeil, fatigue chronique, problèmes digestifs, troubles cutanés (acné, eczéma, psoriasis), gestion du poids, renforcement immunitaire, accompagnement de pathologies chroniques, ou simplement pour adopter une meilleure hygiène de vie. La naturopathie s'adresse à tous, enfants comme adultes."
    },
    {
      id: 'localisation-cabinet',
      question: 'Où se situe le cabinet de naturopathie et réflexologie à Angoulême ?',
      answer: "Le cabinet de Laura Body est situé au 116 rue de Saintes, 16000 Angoulême. Laura Body vous reçoit du mardi au samedi, de 9h à 19h, sur rendez-vous. Vous pouvez réserver directement en ligne ou contacter Laura Body par téléphone au 06 50 15 59 23."
    },
    {
      id: 'massage-shirotchampi',
      question: "Qu'est-ce que le massage Shirotchampi ?",
      answer: "Le massage Shirotchampi est un massage ayurvédique traditionnel indien du cuir chevelu, du visage, du cou et des épaules. Il procure une détente profonde, soulage les maux de tête et les tensions cervicales, améliore la circulation sanguine au niveau du crâne et favorise la santé des cheveux. La séance dure environ 1 heure."
    }
  ];

  return (
    <section id="faq" className="faq-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Questions Fréquentes</span>
          <h2 className="section-title">Naturopathe à Angoulême : Vos Questions</h2>
        </div>
        <div className="faq-grid">
          {faqs.map((faq) => (
            <details key={faq.id} className="faq-item" data-testid={`faq-item-${faq.id}`}>
              <summary className="faq-question">{faq.question}</summary>
              <p className="faq-answer">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
